import styles from '../../../common/styles/Modal.styles';
import Variables from '../../../Variables.styles';

export default {
  ...styles,
  priceContainer: {
    paddingTop: Variables.large,
  },
};
